export * from './requests/index';
export * from './web';
export * from './data';
export const yoloRegistrationPath = '/yolo-regisztracio';
export const accountIdParam = '_a';
export const mfaB2BRegister = 'mfa-b2b-register';
